/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 23/05/2024
 */
import {appHelper} from "../../../utils/helpers/appHelper.js";
import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";

export const TmsDefaults = [
    {
        name: 'tmsAppCache',
        path: appHelper.path.tmsApp + '/cache',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/cache/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppCustomerPersonal',
        path: appHelper.path.tmsApp + '/customer/personal',
        component: routeHelper.asyncComponentWithLoader(() => import('../../customer/views/personal/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppCustomerCompany',
        path: appHelper.path.tmsApp + '/customer/company',
        component: routeHelper.asyncComponentWithLoader(() => import('../../customer/views/company/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppSupplier',
        path: appHelper.path.tmsApp + '/supplier',
        component: routeHelper.asyncComponentWithLoader(() => import('../../product/views/supplier/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppProductType',
        path: appHelper.path.tmsApp + '/product-type/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../product/views/product-type/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppProduct',
        path: appHelper.path.tmsApp + '/product/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../product/views/product/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppUpload',
        path: appHelper.path.tmsApp + '/media-manager',
        component: routeHelper.asyncComponentWithLoader(() => import('../../media/views/media-manager/mediaManager.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppCmsCategory',
        path: appHelper.path.tmsApp + '/term-category/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: true }
    },
    {
        name: 'tmsAppCmsTag',
        path: appHelper.path.tmsApp + '/term-tag/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'tmsAppCmsLocation',
        path: appHelper.path.tmsApp + '/location/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/location/location.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'tmsAppCustomField',
        path: appHelper.path.tmsApp + '/custom-field',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/custom-field/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppOrder',
        path: appHelper.path.tmsApp + '/order/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../product/views/order/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppInvoice',
        path: appHelper.path.tmsApp + '/invoice/tour-product',
        component: routeHelper.asyncComponentWithLoader(() => import('../../product/views/invoice/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'tmsAppCmsTermTripBlog',
        path: appHelper.path.tmsApp + '/term-category/trip-blog',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: true }
    },
    {
        name: 'tmsAppCmsTagTripBlog',
        path: appHelper.path.tmsApp + '/term-tag/trip-blog',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'tmsAppPostTripBlog',
        path: appHelper.path.tmsApp + '/cms-post/trip-blog',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/post/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'tmsAppDestination',
        path: appHelper.path.tmsApp + '/cms-destination',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/destination/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    }
];
